import http from "../net/http-common";
import { SERVER_URL } from "../config";

export const getProteinChainsAndResidues = (pdbFile: File) => {
  const form = new FormData();
  form.append("uploaded_protein_file", pdbFile);

  return http.post(`${SERVER_URL}/pdb/chains`, form, {
    headers: {
      accept: "application/json",
      "Content-Type": "multipart/form-data",
    },
  });
};
